import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { formatCurrency, formatNumber } from 'utils/formats';

import InputCheckbox from 'modules/_shared/components/InputCheckbox';
import { isShareClassVisible } from 'modules/trading/utils/isShareClassVisible';

import { useAcceptTradingOfferModal } from '../context/AcceptTradingOfferModalContext';

const AcceptTradingOfferModalStep3: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useAcceptTradingOfferModal();

  const totalPrice = data.purchaseQuantity * data.offer.sharePrice;

  return (
    <div className="nk-stepper-step active">
      <div className="text-center mb-4">
        <em className="icon ni ni-check-circle fs-24px text-success" />
        <h5 className="mt-2">{t('ConfirmPurchase')}</h5>
        <p className="text-soft">{t('ReviewAndAcceptTermsToFinalize')}</p>
      </div>

      <div className="card card-bordered bg-success-dim mb-4">
        <div className="card-inner text-center">
          <h4 className="text-success mb-1">{formatCurrency(totalPrice)}</h4>
          <p className="mb-0">
            {formatNumber(data.purchaseQuantity)} {t('Shares').toLowerCase()}
            {isShareClassVisible() ? ` ${data.className}` : ''} {t('At')}{' '}
            {formatCurrency(data.offer.sharePrice)}/{t('Share').toLowerCase()}
          </p>
        </div>
      </div>

      <div className="alert alert-light">
        <h6 className="alert-heading fs-14px">{t('OperationTerms')}</h6>
        <ul className="fs-13px mb-0 list-bulleted">
          <li>{t('OperationTermItem1')}</li>
          <li>{t('OperationTermItem2')}</li>
          <li>{t('OperationTermItem3')}</li>
          <li>{t('OperationTermItem4')}</li>
        </ul>
      </div>

      <div className="mt-4">
        <div className="mb-2">
          <InputCheckbox
            id="accept-terms-checkbox"
            label={t('AcceptTermsAndConditionsOfOperation')}
            checked={data.isTermsAccepted}
            onChange={actions.handleToggleTerms}
            href={`/condiciones-ofertas/${data.offer.society}`}
            target="_blank"
            linkLabel={t('ViewConditions')}
          />
        </div>
        <div className="mb-2">
          <InputCheckbox
            id="accept-irrevocable-checkbox"
            label={t('UnderstandIrrevocableAcceptance')}
            checked={data.isIrrevocableAccepted}
            onChange={actions.handleToggleIrrevocable}
          />
        </div>
        <div>
          <InputCheckbox
            id="accept-fiscal-checkbox"
            label={t('AwareFiscalObligations')}
            checked={data.isFiscalAccepted}
            onChange={actions.handleToggleFiscal}
          />
        </div>
      </div>
    </div>
  );
};

export default AcceptTradingOfferModalStep3;
